<template>
    <div class="picker datePicker"
        :class="mustFlag">
        <h6><span></span>受骗时间</h6>
        <div class="text" @click="timeClick()">
            <input
                type="text"
                readonly="readonly"
                id="nowValue"
                placeholder="请选择受骗时间">
        </div>
    </div>
</template>

<script>

    import '../../assets/css/picker.css'
    window._=require('./datePicker.js')

    export default {
        props: ["mustFlag"],
        data () {
            return {
                time : ''
            }
        },
        methods:{
            // 时间组件
            timeClick(){
                let nowValue = document.getElementById('nowValue');
                new _({
                    "type": "3",//0年, 1年月, 2月日, 3年月日
                    "title": '请选择日期',//标题(可选)
                    "maxYear": "2025",//最大年份（可选）
                    "minYear": "2016",//最小年份（可选）
                    "separator": "-",//分割符(可选)
                    "defaultValue": nowValue.value,//默认值（可选）
                    "callBack": function(val) {
                        //回调函数（val为选中的日期）
                        nowValue.value = val;
                        this.time = val
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dataPicker/DatePicker.vue